<div>
  <div class="widget-title">
    <div>
      <div>Day Validations</div>
    </div>
  </div>

  <mat-card *ngFor="let validation of validations$ | async" (click)="toggleValidation(validation)">
    <mat-card-content>
      <mat-icon [style.color]="getSeverityColor(validation.severity)">{{ getSeverityIcon(validation.severity) }}</mat-icon>
      <span [class.confirmed]="validation.isAccepted">{{ validation.message }}</span>
      <ng-container *ngIf="validation.isAccepted">
        Accepted by {{ validation.acceptedBy.firstName }} {{ validation.acceptedBy.lastName }} at {{ validation.updatedAt | date: 'dd-MM-YYYY HH:mm:ss' }}
      </ng-container>
    </mat-card-content>
  </mat-card>

  <div class="no-items" *ngIf="(validations$ | async)?.length === 0">
    <mat-card>
      <mat-card-content>
        <mat-icon>done</mat-icon>
        <span>This day is valid</span>
      </mat-card-content>
    </mat-card>
  </div>
</div>
